import React from "react";
import styled from "styled-components";
import { Bolt, Rocket, Target, UsersRound } from "lucide-react";

const Section = styled.section`
  background: #f6faff;
  padding: 0 0 18px;
`;

const Card = styled.div`
  max-width: 1360px;
  margin: 0 auto;
  padding: 28px 26px;
  border: 1px solid #dce5f6;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 18px 48px rgba(20, 58, 130, 0.05);
`;

const Title = styled.h2`
  color: #071544;
  font-size: 2rem;
  line-height: 1.16;
  font-weight: 920;
  text-align: center;
  margin: 0 0 24px;
  letter-spacing: 0;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 22px 0;
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

const Item = styled.div`
  display: grid;
  grid-template-columns: 70px 1fr;
  gap: 16px;
  align-items: center;
  padding: 8px 24px;
  border-right: 1px solid #dce5f6;

  &:last-child {
    border-right: 0;
  }

  @media (max-width: 900px) {
    &:nth-child(2n) {
      border-right: 0;
    }
  }

  @media (max-width: 560px) {
    border-right: 0;
    padding: 12px 0;
  }

  .icon {
    width: 58px;
    height: 58px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    color: #ffffff;
    background: #0b55e8;
    box-shadow: 0 14px 28px rgba(11, 85, 232, 0.22);
  }

  h3 {
    color: #071544;
    font-size: 1rem;
    line-height: 1.2;
    font-weight: 920;
    margin: 0 0 7px;
    letter-spacing: 0;
  }

  p {
    color: #4f5d82;
    font-size: 0.84rem;
    line-height: 1.5;
    margin: 0;
  }
`;

const items = [
  {
    icon: Target,
    title: "Run operations",
    copy: "Streamline daily operations and improve efficiency across your organization."
  },
  {
    icon: UsersRound,
    title: "Manage teams",
    copy: "Plan work, collaborate and track progress in one connected workspace."
  },
  {
    icon: Rocket,
    title: "Engage customers",
    copy: "Build relationships, run campaigns and deliver experiences customers love."
  },
  {
    icon: Bolt,
    title: "Launch faster",
    copy: "Go from idea to execution with modern tools and ready-to-use workflows."
  }
];

const Features = () => {
  return (
    <Section>
      <Card>
        <Title>What businesses can do with Willovate</Title>
        <Grid>
          {items.map((item) => {
            const Icon = item.icon;
            return (
              <Item key={item.title}>
                <span className="icon"><Icon size={25} /></span>
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.copy}</p>
                </div>
              </Item>
            );
          })}
        </Grid>
      </Card>
    </Section>
  );
};

export default Features;
